export interface TareaActividad {
  id: string;
  subjectName: string;
  periodName: string;
  periodNumber: number;
  tipoContenedor: number;
  evaluationType: number;
  name: string | null;
  description: string | null;
  fechaEntrega: string | null;
  elaborationDate: string | null;
  createdAt: string;
  calificada: boolean;
  calificacion: number | null;
}

export interface TareasState {
  studentId: string | null;
  tareas: TareaActividad[];
  loading: boolean;
  error: string | null;
}

export const initialTareasState: TareasState = {
  studentId: null,
  tareas: [],
  loading: false,
  error: null,
};
